const NETWORK_DOMAIN = 'network'

const NETWORK_ACTION = {
  ADD_REQUEST: 'NETWORK_ADD_REQUEST',
  DELETE_REQUEST: 'NETWORK_DELETE_REQUEST',
  ONLINE: 'NETWORK_ONLINE',
  OFFLINE: 'NETWORK_OFFLINE',
  CONNECTED: 'NETWORK_CONNECTED',
  NOT_CONNECTED: 'NETWORK_NOT_CONNECTED',
  DELETE_FAILED_REQUESTS: 'NETWORK_DELETE_FAILED_REQUESTS',
  RESET_REQUESTS: 'NETWORK_RESET_REQUESTS',
  DELETE_PENDING_REQUESTS_STATUS: 'NETWORK_DELETE_PENDING_REQUESTS_STATUS',
  RESET_INSTANCES_AND_DOMAINS_STATUS: 'NETWORK_RESET_INSTANCES_AND_DOMAINS_STATUS',
  INCREMENT_RETRY_COUNT: 'NETWORK_INCREMENT_RETRY_COUNT',
  UPDATE_IS_SENDING_DATA: 'NETWORK_UPDATE_IS_SENDING_DATA',
  RESET_IS_SENDING_DATA: 'NETWORK_RESET_IS_SENDING_DATA'
}

const NETWORK_ENDPOINT = {
  HEALTHCHECK: '/healthz'
}

const NETWORK_KEY = {
  IS_ONLINE: 'isOnline',
  IS_CONNECTED: 'isConnected',
  REQUESTS: 'requests',
  IS_SENDING_DATA: 'isSendingData'
}

const NETWORK_PATH = {
  IS_ONLINE: `${NETWORK_DOMAIN}.${NETWORK_KEY.IS_ONLINE}`,
  IS_CONNECTED: `${NETWORK_DOMAIN}.${NETWORK_KEY.IS_CONNECTED}`,
  REQUESTS: `${NETWORK_DOMAIN}.${NETWORK_KEY.REQUESTS}`,
  IS_SENDING_DATA: `${NETWORK_DOMAIN}.${NETWORK_KEY.IS_SENDING_DATA}`
}

const NETWORK_STATE = {
  [NETWORK_KEY.IS_ONLINE]: true,
  [NETWORK_KEY.IS_CONNECTED]: true,
  [NETWORK_KEY.REQUESTS]: [],
  [NETWORK_KEY.IS_SENDING_DATA]: false
}

const NETWORK_REQUEST_PATH = {
  ACTION: 'action',
  RETRY_COUNT: 'retryCount',
  ACTION_PATH: 'action.payload.path',
  ACTION_TYPE: 'action.type',
  ACTION_OLD_PATH: 'action.payload.oldPath',
  ACTION_DOMAIN_LIST_PATH: 'action.payload.domainListPath'
}

export {
  NETWORK_DOMAIN,
  NETWORK_KEY,
  NETWORK_ACTION,
  NETWORK_ENDPOINT,
  NETWORK_PATH,
  NETWORK_STATE,
  NETWORK_REQUEST_PATH
}
